// ============================================
// label-web/src/pages/Promotions.js (Admin — Saskara Record)
// Tambahkan route di App.js: <Route path="/promotions" element={<Promotions />} />
// Tambahkan menu di Layout.js sidebar: "Promo & Diskon"
// ============================================
import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'https://admin.saskararecord.com/api';

const emptyForm = {
  id: null,
  title: '',
  description: '',
  discount_percent: '',
  promo_code: '',
  image_url: '',
  is_active: true,
  expires_at: '',
};

export default function Promotions() {
  const [promotions, setPromotions] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [editing, setEditing] = useState(false);
  const [message, setMessage] = useState('');
  const token = localStorage.getItem('admin_token');

  useEffect(() => {
    fetchPromotions();
  }, []);

  const fetchPromotions = async () => {
    try {
      const res = await axios.get(`${API_BASE}/admin/promotions`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setPromotions(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  const resetForm = () => {
    setForm(emptyForm);
    setEditing(false);
  };

  const handleSubmit = async () => {
    if (!form.title) {
      setMessage('Judul promo wajib diisi.');
      return;
    }
    try {
      const payload = {
        title: form.title,
        description: form.description,
        discount_percent: form.discount_percent ? parseInt(form.discount_percent) : null,
        promo_code: form.promo_code,
        image_url: form.image_url,
        is_active: form.is_active,
        expires_at: form.expires_at || null,
      };

      if (editing && form.id) {
        await axios.put(`${API_BASE}/admin/promotions/${form.id}`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setMessage('Promo berhasil diupdate.');
      } else {
        await axios.post(`${API_BASE}/admin/promotions`, payload, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setMessage('Promo baru berhasil dibuat.');
      }
      resetForm();
      fetchPromotions();
    } catch (err) {
      setMessage(`Gagal: ${err.response?.data?.error || err.message}`);
    }
  };

  const handleEdit = (promo) => {
    setForm({
      id: promo.id,
      title: promo.title,
      description: promo.description || '',
      discount_percent: promo.discount_percent || '',
      promo_code: promo.promo_code || '',
      image_url: promo.image_url || '',
      is_active: promo.is_active,
      expires_at: promo.expires_at ? promo.expires_at.slice(0, 10) : '',
    });
    setEditing(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Hapus promo ini? Tidak bisa dibatalkan.')) return;
    try {
      await axios.delete(`${API_BASE}/admin/promotions/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchPromotions();
    } catch (err) {
      setMessage(`Gagal hapus: ${err.response?.data?.error || err.message}`);
    }
  };

  const toggleActive = async (promo) => {
    try {
      await axios.put(
        `${API_BASE}/admin/promotions/${promo.id}`,
        { ...promo, is_active: !promo.is_active },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      fetchPromotions();
    } catch (err) {
      console.error(err);
    }
  };

  const inputStyle = {
    display: 'block',
    margin: '8px 0 16px',
    padding: 8,
    width: '100%',
    background: '#2A2A2E',
    color: '#B5B5BC',
    border: '1px solid #48484E',
    borderRadius: 4,
  };

  return (
    <div style={{ padding: 24, color: '#B5B5BC' }}>
      <h2 style={{ color: '#C9A66B' }}>Promo & Diskon</h2>
      <p style={{ fontSize: 13, color: '#9A9AA2', marginBottom: 20 }}>
        Promo aktif dengan tanggal terbaru otomatis muncul di welcome email fan baru.
      </p>

      <div style={{ background: '#1D1D20', padding: 20, borderRadius: 8, marginBottom: 24 }}>
        <h3 style={{ color: '#C9A66B', marginTop: 0 }}>{editing ? 'Edit Promo' : 'Buat Promo Baru'}</h3>

        <label>Judul Promo:</label>
        <input
          type="text"
          value={form.title}
          onChange={(e) => setForm({ ...form, title: e.target.value })}
          placeholder="Contoh: Diskon Merch Anniversary"
          style={inputStyle}
        />

        <label>Deskripsi:</label>
        <textarea
          value={form.description}
          onChange={(e) => setForm({ ...form, description: e.target.value })}
          rows={3}
          style={inputStyle}
        />

        <div style={{ display: 'flex', gap: 16 }}>
          <div style={{ flex: 1 }}>
            <label>Diskon (%):</label>
            <input
              type="number"
              value={form.discount_percent}
              onChange={(e) => setForm({ ...form, discount_percent: e.target.value })}
              style={inputStyle}
            />
          </div>
          <div style={{ flex: 1 }}>
            <label>Kode Promo:</label>
            <input
              type="text"
              value={form.promo_code}
              onChange={(e) => setForm({ ...form, promo_code: e.target.value })}
              placeholder="SASKARA20"
              style={inputStyle}
            />
          </div>
        </div>

        <label>URL Gambar (opsional):</label>
        <input
          type="text"
          value={form.image_url}
          onChange={(e) => setForm({ ...form, image_url: e.target.value })}
          style={inputStyle}
        />

        <label>Berlaku Sampai (opsional):</label>
        <input
          type="date"
          value={form.expires_at}
          onChange={(e) => setForm({ ...form, expires_at: e.target.value })}
          style={inputStyle}
        />

        <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
          <input
            type="checkbox"
            checked={form.is_active}
            onChange={(e) => setForm({ ...form, is_active: e.target.checked })}
          />
          Aktif sekarang
        </label>

        <div style={{ display: 'flex', gap: 12 }}>
          <button
            onClick={handleSubmit}
            style={{ background: '#C9A66B', color: '#18181B', border: 'none', padding: '10px 20px', borderRadius: 4, fontWeight: 'bold', cursor: 'pointer' }}
          >
            {editing ? 'Simpan Perubahan' : 'Buat Promo'}
          </button>
          {editing && (
            <button
              onClick={resetForm}
              style={{ background: 'transparent', color: '#9A9AA2', border: '1px solid #48484E', padding: '10px 20px', borderRadius: 4, cursor: 'pointer' }}
            >
              Batal
            </button>
          )}
        </div>

        {message && <p style={{ marginTop: 12 }}>{message}</p>}
      </div>

      <h3 style={{ color: '#C9A66B' }}>Daftar Promo</h3>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ borderBottom: '1px solid #48484E' }}>
            <th style={{ textAlign: 'left', padding: 8 }}>Judul</th>
            <th style={{ textAlign: 'left', padding: 8 }}>Diskon</th>
            <th style={{ textAlign: 'left', padding: 8 }}>Kode</th>
            <th style={{ textAlign: 'left', padding: 8 }}>Berlaku Sampai</th>
            <th style={{ textAlign: 'left', padding: 8 }}>Status</th>
            <th style={{ textAlign: 'left', padding: 8 }}>Aksi</th>
          </tr>
        </thead>
        <tbody>
          {promotions.map((promo) => (
            <tr key={promo.id} style={{ borderBottom: '1px solid #2A2A2E' }}>
              <td style={{ padding: 8 }}>{promo.title}</td>
              <td style={{ padding: 8 }}>{promo.discount_percent ? `${promo.discount_percent}%` : '-'}</td>
              <td style={{ padding: 8 }}>{promo.promo_code || '-'}</td>
              <td style={{ padding: 8 }}>{promo.expires_at ? new Date(promo.expires_at).toLocaleDateString('id-ID') : 'Tanpa batas'}</td>
              <td style={{ padding: 8 }}>
                <span
                  onClick={() => toggleActive(promo)}
                  style={{ cursor: 'pointer', color: promo.is_active ? '#4ADE80' : '#9A9AA2' }}
                >
                  {promo.is_active ? '● Aktif' : '○ Nonaktif'}
                </span>
              </td>
              <td style={{ padding: 8 }}>
                <button onClick={() => handleEdit(promo)} style={{ marginRight: 8, background: 'transparent', color: '#C9A66B', border: 'none', cursor: 'pointer' }}>Edit</button>
                <button onClick={() => handleDelete(promo.id)} style={{ background: 'transparent', color: '#EF4444', border: 'none', cursor: 'pointer' }}>Hapus</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
